'use strict'

import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

import auth from './auth.js'

import message from './modules/message'
import progress from './modules/progress'
import others from './modules/others'
import barcodes from './modules/barcodes'
import panels from './modules/panels'
import ProjectStore from './modules/projects.js'
import error from './modules/error'

import runs from './modules/runs'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex) // это плагин подключается

import api from './../api/index'

const store = new Vuex.Store({
	modules: {
		auth,
		error,

		message,
		progress,
		others,
		barcodes,
		panels,
		projects: new ProjectStore(api.projects),

		runs,
	},
	strict: debug,
	plugins: debug ? [createLogger(),] : []
});

export default store;